import { useReleaseFlag } from '@libs/contexts';
import { AuthErrorViewWithBox } from '@libs/templates/template-pages';
import { Box } from '@mui/material';
import { BackDropSpinnerProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';
import { AiHeadMenu } from '../components/AiHeadMenu';
import { AiCompanyProvider } from '../context/CompanyContext';

export function AiLayout() {
  const { isEnabled, isLoading } = useReleaseFlag('release.agent.chat_panel_v1');

  if (isLoading || !isEnabled) {
    return <AuthErrorViewWithBox />;
  }

  return (
    <AiCompanyProvider>
      <BackDropSpinnerProvider>
        <Box sx={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <AiHeadMenu />
          <Outlet />
        </Box>
      </BackDropSpinnerProvider>
    </AiCompanyProvider>
  );
}
